module.exports = __webpack_public_path__ + "img/Desktop-screenshot.e6afab9e.png";